import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Row, Tooltip } from "antd";
import { sortByAmount, sortByAlpha } from "../utils";
import GraphComponent from "./salesRepAndActivityGraph";
import TotalVsCompletedGraph from "./totalHours";
import { ReactComponent as SortAlphabetically } from "../../../assets/sortAlphabetically.svg";
import { ReactComponent as SortByAmount } from "../../../assets/sortByAmount.svg";
import SpinnerComponent from "../../../components/spinner";

const ActivitiesReporting = () => {
  const [graphdata, setGraphData] = useState([]);
  const [sortOrder, setSortOrder] = useState({
    alphaSort: false,
    sortByAmount: false,
  });
  const { docTypeGrpahData, fetchingLoading } = useSelector(
    (state) => state.imsReducer
  );

  useEffect(() => {
    setGraphData(docTypeGrpahData);
  }, [docTypeGrpahData]);

  const handleSortClientByAlpha = () => {
    setSortOrder((prev) => ({
      ...sortOrder,
      alphaSort: !prev.alphaSort,
    }));
    let res = sortByAlpha(docTypeGrpahData, sortOrder.alphaSort);
    setGraphData(res);
  };

  const handleSortClientByAmount = () => {
    setSortOrder((prev) => ({
      ...sortOrder,
      sortByAmount: !prev.sortByAmount,
    }));
    let res = sortByAmount(docTypeGrpahData, sortOrder.sortByAmount);
    setGraphData(res);
  };

  return (
    <Row className="doc-control-parent-row">
      <Col span={24} className="heading-col">
        <Row>
          <Col>
            <span className="heading-span">DOCUMENT CONTROL REPORTING</span>
          </Col>
        </Row>
      </Col>
      <Col span={24} className="graph-section">
        {fetchingLoading ? (
          <div className="spinner-div">
            <SpinnerComponent fontSize={50} />
          </div>
        ) : (
          <Row gutter={[20, 40]}>
            <Col md={16} lg={16} xl={16} xxl={16}>
              <div className="production-by-client-div">
                <span className="graph-text-span">
                  Total vs Completed by Document Type
                </span>
                <Tooltip
                  arrowPointAtCenter
                  placement="top"
                  title="Sort by Alphabetically"
                >
                  <SortAlphabetically
                    className="sort-icons"
                    onClick={handleSortClientByAlpha}
                  />
                </Tooltip>
                <Tooltip
                  arrowPointAtCenter
                  placement="top"
                  title={`Sort by Amount`}
                >
                  <SortByAmount
                    className="sort-icons"
                    onClick={handleSortClientByAmount}
                  />
                </Tooltip>
              </div>
              <div className="ordered-compl-label-with-text">
                <div className="ordered-div">
                  <span className="ordered-dot"></span>Total
                </div>
                <div className="completed-div">
                  <span className="completed-dot"></span>
                  Completed
                </div>
              </div>
              <GraphComponent data={graphdata} />
            </Col>
            <Col md={8} lg={8} xl={8} xxl={8}>
              <span className="graph-text-span">Total vs Completed</span>
              <div className="ordered-compl-label-with-text">
                <div className="ordered-div">
                  <span className="ordered-dot"></span>Total
                </div>
                <div className="completed-div">
                  <span className="completed-dot"></span>
                  Completed
                </div>
              </div>
              <TotalVsCompletedGraph />
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default ActivitiesReporting;
